/**
 * Constantes de negocio hardcodeadas.
 *
 * TODO(backend): Estos valores deberían centralizarse en un endpoint del backend
 * (ej: GET /rrapi/config/business) para poder actualizarlos sin deploy de frontend.
 * Por ahora se mantienen aquí como single source of truth del frontend.
 */

// --- Reembolsos ---
export const REFUND_PROCESSING_DAYS = { min: 5, max: 9 };

// --- Envíos ---
export const SHIPPING_DELIVERY_TIMES = {
  LIMA: { min: 1, max: 2, label: 'Lima Metropolitana' },
  COSTA: { min: 2, max: 3, label: 'Costa' },
  SIERRA_SELVA: { min: 3, max: 5, label: 'Sierra y Selva' },
};

// --- Soporte ---
export const SUPPORT_HOURS = {
  WEEKDAY: '9am a 6pm',
  SATURDAY: '9am a 1pm',
};

// --- Pagos ---
export const PAYMENT_VALIDATION_MINUTES = 60;

// --- Validaciones bancarias ---
export const BANK_ACCOUNT_MIN_LENGTH = 8;
export const BANK_ACCOUNT_HOLDER_MIN_LENGTH = 4;

// --- Ofertas ---
/**
 * Tope de vigencia de una oferta, en días desde hoy.
 * Espejo de `Trip::OFFER_EXPIRATION_MAX_DAYS` (backend): el server calcula
 * `offer_expiration_date = min(arrive_date, hoy + OFFER_EXPIRATION_MAX_DAYS)`
 * y clampea al recibir la oferta. El frontend solo acota los controles.
 */
export const OFFER_EXPIRATION_MAX_DAYS = 4;

// --- Capacitación ---
export const TRAINING_DURATION_MINUTES = 3;
